/* GENERATED FILE — DO NOT EDIT.
 *
 * W125 part 2 — the tested max, emitted from the one rule the app compiles:
 *   HybridTrainer/Services/TestedMax.swift
 *
 * Regenerate:  KATA_EMIT_WEB_TOKENS=1 ./tools/engine-tests/run.sh
 * The harness gate `w125-the-1rm` regenerates this in memory on every run and fails if it differs;
 * `testedMax.test.ts` holds both functions to the Swift's own answers (`SWIFT_STANDING_PROBES`, `SWIFT_SNAP_PROBES`).
 *
 * A tested max is the 1RM until a set logged on a LATER day estimates higher (beaten; the test day's own sets never
 * beat it) or it is more than 56 days old (expired); beaten wins. Days are `YYYY-MM-DD` strings.
 */

export const TESTED_MAX_VALID_DAYS = 56;
export const TESTED_MAX_STEP = 0.5;
export const TESTED_MAX_CEILING_KG = 300;
export const TESTED_MAX_BODY_CEILING_KG = 150;
export const TESTED_MAX_BEATEN = " · beaten";
export const TESTED_MAX_EXPIRED = " · over 8 weeks";

export type TestedMaxStanding = "current" | "beaten" | "expired";
export type TestedMaxEntry = { readonly kg: number; readonly testedOn: string };
export type TestedMaxEstimate = { readonly date: string; readonly value: number };

/** A `YYYY-MM-DD` day (a longer ISO string is read by its first ten characters) as a whole day number. */
const dayNumber = (ymd: string): number => {
  return Math.round(Date.parse(`${ymd.slice(0, 10)}T00:00:00Z`) / 86_400_000);
};

/** `TestedMax.standing(of:estimates:now:)`. */
export function testedMaxStanding(t: TestedMaxEntry, estimates: readonly TestedMaxEstimate[], today: string): TestedMaxStanding {
  const testDay = dayNumber(t.testedOn);
  if (estimates.some((e) => dayNumber(e.date) > testDay && e.value > t.kg + 1e-9)) return "beaten";
  return dayNumber(today) - testDay > TESTED_MAX_VALID_DAYS ? "expired" : "current";
}

/** `TestedMax.snapped(_:body:)` — Swift's `.rounded()` is half AWAY from zero, so the sign is taken off first. */
export function snappedTestedMax(kg: number, body: boolean): number {
  const top = body ? TESTED_MAX_BODY_CEILING_KG : TESTED_MAX_CEILING_KG;
  const x = kg / TESTED_MAX_STEP;
  return Math.min(top, Math.max(0, Math.sign(x) * Math.round(Math.abs(x)) * TESTED_MAX_STEP));
}

/** Swift's own answers — the tested max is 100 kg on `testedOn`. */
export const SWIFT_STANDING_PROBES: readonly { readonly name: string; readonly testedOn: string; readonly kg: number; readonly estimates: readonly TestedMaxEstimate[]; readonly today: string; readonly standing: TestedMaxStanding }[] = [
  { name: "same-day higher set (warm-ups, back-offs)", testedOn: "2026-08-12", kg: 100, estimates: [{ date: "2026-08-12", value: 110 }], today: "2026-08-22", standing: "current" },
  { name: "next-day higher set", testedOn: "2026-08-12", kg: 100, estimates: [{ date: "2026-08-13", value: 110 }], today: "2026-08-22", standing: "beaten" },
  { name: "next-day equal set", testedOn: "2026-08-12", kg: 100, estimates: [{ date: "2026-08-13", value: 100 }], today: "2026-08-22", standing: "current" },
  { name: "an earlier day's higher set", testedOn: "2026-08-12", kg: 100, estimates: [{ date: "2026-08-11", value: 120 }], today: "2026-08-22", standing: "current" },
  { name: "56 days old", testedOn: "2026-08-12", kg: 100, estimates: [], today: "2026-10-07", standing: "current" },
  { name: "57 days old", testedOn: "2026-08-12", kg: 100, estimates: [], today: "2026-10-08", standing: "expired" },
  { name: "beaten AND 57 days (beaten wins)", testedOn: "2026-08-12", kg: 100, estimates: [{ date: "2026-08-15", value: 105 }], today: "2026-10-08", standing: "beaten" },
  { name: "no estimates", testedOn: "2026-08-12", kg: 100, estimates: [], today: "2026-08-12", standing: "current" },
];

/** Swift's own answers on the ruler. */
export const SWIFT_SNAP_PROBES: readonly { readonly kg: number; readonly body: boolean; readonly snapped: number }[] = [
  { kg: 102.3, body: false, snapped: 102.5 },
  { kg: 102.2, body: false, snapped: 102 },
  { kg: 102.25, body: false, snapped: 102.5 },
  { kg: -0.25, body: false, snapped: 0 },
  { kg: -0.75, body: false, snapped: 0 },
  { kg: 400, body: false, snapped: 300 },
  { kg: 160, body: true, snapped: 150 },
  { kg: 40.25, body: true, snapped: 40.5 },
  { kg: 0, body: false, snapped: 0 },
];
